import { render } from "./PartnerBuild.vue?vue&type=template&id=6fe1fd7f"
import script from "./PartnerBuild.vue?vue&type=script&lang=js"
export * from "./PartnerBuild.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__